<template>
  <div class="index">
      <div class="header clearfix">
        <div class="header-main">
          <span class="fl logo-icon">
           <img class="logo" src="../../assets/logo-white.png" alt="" width="210">
          </span>
          <ul class="fl">
            <li v-for="(item, index) in navList" :key="index" @click="jump(index)" :class="{'active': isActive == index}">{{item}}</li>
            <li class="list">
              <!-- 亚商大家庭 <span></span> -->
              <!-- <ul class="second-list">
                <li> -->
                  <a href="https://www.abc-group.cn/" target="_blank"><span></span> 亚商集团</a>
                <!-- </li>
              </ul> -->
            </li>
          </ul>
          <a href="https://www.abc-group.cn/anniversary" target="_blank" class="thirty-year"><img src="./30year-icon.png" alt=""></a>
        </div>
        <!-- <span class="fr language">EN</span> -->
      </div>
      <div class="banner"><img src="../../assets/banner.jpg" alt="" width="100%"></div>
      <KnowUs></KnowUs>
      <Team></Team>
      <FundClassify></FundClassify>
      <InvestCase></InvestCase>
      <News></News>
      <ContactUs></ContactUs>
  </div>
</template>

<script>
$(function () {
  $('.list').hover(function () {
    $(this).find('ul').slideDown()
  }, function () {
    $(this).find('ul').slideUp()
  })
})
import KnowUs from '../knowUs/knowUs'
import Team from '../team/team'
import FundClassify from '../fundClassify/fundClassify'
import InvestCase from '../investCase/investCase'
import News from '../news/news'
import NewsMore from '../newsMore/newsMore'
import ContactUs from '../contactUs/contactUs'
export default {
  name: 'Index',
  data () {
    return {
      isActive: -1,
      navList: ['认识我们', '管理团队', '基金分类', '投资案例', '最新资讯', '联系我们'],
      anchor: (this.$route.params.renderContent >= 0) ? this.$route.params.renderContent : -1
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.anchorPoint()
      window.addEventListener('scroll', this.onScroll)
      console.log(this.anchor)
    })
  },
  methods: {
    // 通过新闻页传过来的参数来进行首页相应模块的定位
    anchorPoint () {
      let _scroll = document.documentElement.scrollTop || document.body.scrollTop
      // console.log(_scroll);
      if (this.anchor == 0) {
        document.documentElement.scrollTop = 603
      } else if (this.anchor == 1) {
        document.documentElement.scrollTop = 1670
      } else if (this.anchor == 2) {
        document.documentElement.scrollTop = 2866
      } else if (this.anchor == 3) {
        document.documentElement.scrollTop = 3751
      } else if (this.anchor == 4) {
        document.documentElement.scrollTop = 4663
      } else if (this.anchor == 5) {
        document.documentElement.scrollTop = 5325
      } else {
        document.documentElement.scrollTop = 0
        // console.log(document.documentElement.scrollTop);
      }
    },
    onScroll () {
      // console.log('scroll');
      let scrolled = document.documentElement.scrollTop || document.body.scrollTop
      // 判断数字分别为导航锚点对应的距离
      // $('.header').addClass('active');
      if (scrolled >= 5225) {
        $('.header').addClass('active')
        this.isActive = 5
      } else if (scrolled < 5225 && scrolled >= 4563) {
        this.isActive = 4
        $('.header').addClass('active')
      } else if (scrolled < 4563 && scrolled >= 3615) {
        this.isActive = 3
        $('.header').addClass('active')
      } else if (scrolled < 3615 && scrolled >= 2766) {
        this.isActive = 2
        $('.header').addClass('active')
      } else if (scrolled < 2766 && scrolled >= 1507) {
        this.isActive = 1
        $('.header').addClass('active')
      } else if (scrolled < 1570 && scrolled >= 503) {
        $('.header').addClass('active')
        this.isActive = 0
      } else {
        $('.header').removeClass('active')
        this.isActive = -1
      }
      // console.log('滚动高度：'+scrolled);
    },
    jump (index) {
      // console.log('index: '+ index);
      let jump = document.querySelectorAll('.content')
      //   console.log(jump);
      let total = jump[index].offsetTop - 100
      let distance = document.documentElement.scrollTop - 100 || document.body.scrollTop - 100
      // console.log("要滚动到的对应高度： "+total + ", 滚动条目前所处的高度："+distance);
      // 平滑滚动 时长500ms，每10ms一跳 共50跳
      let step = total / 50
      if (distance > 600) {
        $('.header').addClass('active')
      } else {
        $('.header').removeClass('active')
      }
      if (total > distance) {
        smoothDown()
      } else {
        let newTotal = distance - total
        step = newTotal / 50
        smoothUp()
      }
      function smoothDown () {
        if (total > distance) {
          distance += step
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          // window.pageYOffset = distance;
          setTimeout(smoothDown, 10)
        } else {
          document.body.scrollTop = total
          document.documentElement.scrollTop = total
          // window.pageYOffset = total;
        }
      }
      function smoothUp () {
        if (distance > total) {
          distance -= step
          document.body.scrollTop = distance // Chrome
          document.documentElement.scrollTop = distance // Firefox
          window.pageYOffset = distance // Safari
          setTimeout(smoothUp, 10)
        } else {
          document.body.scrollTop = total
          document.documentElement.scrollTop = total
          // window.pageYOffset = total;
        }
      }
      this.isActive = index
    }
  },
  components: {
    KnowUs,
    Team,
    FundClassify,
    InvestCase,
    News,
    ContactUs,
    NewsMore
  }
}
</script>

<style scoped>
.header{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-width: 1310px;
  /* min-width: 1340px; */
  height: 100px;
  background: rgba(255, 255, 255, 0.2);
  -moz-background: rgba(255, 255, 255, 0.2);
  padding: 20px 200px;
  box-sizing: border-box;
  /* transition: all 0.8s;
  -moz-transition: all 0.8s; */
  z-index: 99999;
}
.header .header-main{
  width: 100%;
  height: 100%;
  margin: 0 auto;
}

.header .thirty-year{
  position: absolute;
  top: -8px;
  right: 12%;
}
.header.active{
  background: #333367;
}
.header .logo-icon{
  width: 20%;
}
.header ul{
  display: table;
  table-layout: fixed;
  width: 70%;
  padding-left: 4%;
  box-sizing: border-box;
}
.header li{
  display: table-cell;
  /* width: 8.75%; */
  min-width: 104px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}
.header li.active{
  color: #e53c6d;
}
.header li{
  font-size: 17px;
}
.header span.language{
  display: inline-block;
  color: #fff;
  border: 1px solid #fff;
  width: 34px;
  height: 34px;
  line-height: 34px;
  border-radius: 50%;
  text-align: center;
  margin-top: 12px;
  cursor: pointer;
}
.content{
  max-width: 1520px;
  margin: 0 auto;
}
.banner{
    min-width: 1200px;
}
.header .list{
  position: relative;
}
.header .list > span{
  background: url('./slide-gray.png') no-repeat 0 0;
  display: inline-block;
  width: 11px;
  height: 7px;
  vertical-align: middle;
  background-size: 11px 7px;
}
.header .list a{
  color: #fff;
}
@media screen and (max-width: 1450px) {
  .header ul{
    width: 80%;
    padding-left: 2px;
  }
  .header .thirty-year{
    right: 5%;
  }
  .header .logo-icon  img{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue